import BaseModelComponent from '../../base/base_model_component';
import _ from '../../utils/underscore';

const CASHIER_ONLY = 'cashier_only';
const INLINE = 'inline';

class LoggedinModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'LoggedinModel';


    /**
     * @property
     * @type {Object}
     * @private
     */
    _map = {
        gametype : CASHIER_ONLY,
        gameName : CASHIER_ONLY,
        isReal   : CASHIER_ONLY,
        postCTAClickedFn: INLINE
    };


    /**
     * @param params
     */
    init(params = {}) {
        this
            ._setLayout(params.layout)
            ._setLayoutType(params.layoutType)
            ._setOverlayPriority(params.overlayPriority)
            ._setSilentMode(params.silentMode)
            ._setShowBalance(params.showBalance)
            ._setShowMenu(params.showMenu)
            ._setEnvironment(params.env)
            ._setShowUsername(params.showUsername)
            ._setShowUserBadge(params.showUserBadge)
            ._setCashierOpenType(params.cashierOpenType)
            ._setGameType(params.gametype)
            ._setGameName(params.gameName)
            ._setGameIsReal(params.isReal)
            ._setShowCashier(params.showCashier)
            ._setPostLoginShowGreeting(params.postLoginShowGreeting)
            ._setPostCTAClickedFn(params.postCTAClickedFn)
            ._setPostLoginLayoutPC(params.postLoginLayoutPC)
            ._setPostLoginLayoutMobile(params.postLoginLayoutMobile)
            ._setStyleSelectors(params.styleSelectors);
    }


    /**
     * Get map by state.
     *
     *
     * @param state
     * @returns {{}}
     */
    getMapByState(state) {
        let map = {};

        for(let prop in this._map) {
            if (!(this._map[prop] === state)) {
                continue;
            }

            map[prop] = this['_' + prop];
        }

        return map;
    }


    /**
     * Set the current layout.
     *
     *
     * @param layout
     * @returns {LoggedinModel}
     * @private
     */
    _setLayout(layout = 'inline') {
        this.layout = layout;

        return this;
    }


    /**
     * Set game type will be valid only for game panel.
     *
     * @param gametype
     * @returns {WelcomeModel}
     * @private
     */
    _setGameType(gametype) {
        if (!_.isNumber(gametype)) {
            return this;
        }

        this._gametype = gametype;
        return this;
    }


    /**
     * Set game name will be valid only for game panel.
     *
     * @param gameName
     * @returns {WelcomeModel}
     * @private
     */
    _setGameName(gameName) {
        if (!_.isString(gameName)) {
            return this;
        }

        this._gameName = gameName;
        return this;
    }


    /**
     * Set game name will be valid only for game panel.
     *
     * @param isReal
     * @returns {WelcomeModel}
     * @private
     */
    _setGameIsReal(isReal) {
        if (!_.isBoolean(isReal)) {
            return this;
        }

        this._isReal = isReal;
        return this;
    }


    /**
     *
     * @param layoutType
     * @returns {LoggedinModel}
     * @private
     */
    _setLayoutType(layoutType) {
        this._layoutType = layoutType;
        return this;
    }


    /**
     * Set the environment the component opened in.
     *
     * @param env
     * @returns {WelcomeModel}
     * @private
     */
    _setEnvironment(env = 'lobby') {
        if (!_.isString(env)) {
            this._environment = 'lobby';
            return this;
        }

        this._environment = env;
        return this;
    }


    /**
     *
     * @param overlayPriority
     * @returns {LoggedinModel}
     * @private
     */
    _setOverlayPriority(overlayPriority) {
        this._overlayPriority = overlayPriority;
        return this;
    }


    /**
     *
     * @param silentMode
     * @returns {LoggedinModel}
     * @private
     */
    _setSilentMode(silentMode) {
        this._silentMode = silentMode;
        return this;
    }


    /**
     *
     * @param cashierOpenType
     * @returns {GameServiceModel}
     * @private
     */
    _setCashierOpenType(cashierOpenType) {
        this._cashierOpenType = cashierOpenType;
        return this;
    }


    /**
     *
     * @param showBalance
     * @returns {LoggedinModel}
     * @private
     */
    _setShowBalance(showBalance) {
        this._showBalance = showBalance;
        return this;
    }


    /**
     *
     * @param showUsername
     * @returns {LoggedinModel}
     * @private
     */
    _setShowUsername(showUsername) {
        this._showUsername = showUsername;
        return this;
    }


    /**
     * @param showUserBadge
     * @returns {LoggedinModel}
     * @private
     */
    _setShowUserBadge(showUserBadge) {
        this._showUserBadge = showUserBadge;
        return this;
    }


    /**
     *
     * @param showMenu
     * @returns {LoggedinModel}
     * @private
     */
    _setShowMenu(showMenu) {
        this._showMenu = showMenu;

        return this;
    }


    /**
     *
     * @param showCashier
     * @returns {LoggedinModel}
     * @private
     */
    _setShowCashier(showCashier) {
        this._showCashier = showCashier;

        return this;
    }


    /**
     *
     * @param postLoginShowGreeting
     * @returns {LoggedinModel}
     * @private
     */
    _setPostLoginShowGreeting(postLoginShowGreeting) {
        this._postLoginShowGreeting = postLoginShowGreeting;
        return this;
    }


    /**
     * Set handle function that will be called on balance click
     * @param fnName
     * @returns {LoggedinModel}
     * @private
     */
    _setPostCTAClickedFn(fnName) {
        if (!_.isString(fnName)) {
            return this;
        }

        this._postCTAClickedFn = fnName;
        return this;
    }


    /**
     * Set overriding for pc pre login layout
     * @param postLoginLayoutPC
     * @returns {LoggedinModel}
     * @private
     */
    _setPostLoginLayoutPC(postLoginLayoutPC) {
        this._postLoginLayoutPC = postLoginLayoutPC;
        return this;
    }


    /**
     * Set overriding for mobile pre login layout
     * @param preLoginLayoutPC
     * @returns {LoggedinModel}
     * @private
     */
    _setPostLoginLayoutMobile(postLoginLayoutMobile) {
        this._postLoginLayoutMobile = postLoginLayoutMobile;
        return this;
    }


    /**
     * Set custom selectors to component HTML elements
     * @param styleSelectors
     * @returns {WelcomeModel}
     * @private
     */
    _setStyleSelectors(styleSelectors) {
        this._styleSelectors = styleSelectors;
        return this;
    }


    /**
     * Get the current component layout.
     *
     * @returns {*}
     * @public
     */
    getLayout() {
        return this.layout;
    }


    /**
     *
     * @returns {*}
     */
    getLayoutType() {
        return this._layoutType
    }


    /**
     *
     * @returns {*}
     */
    getShowBalance() {
        return this._showBalance;
    }


    /**
     *
     * @returns {*}
     */
    getShowUsername() {
        return this._showUsername;
    }


    /**
     *
     * @returns {*}
     */
    getShowMenu() {
        return this._showMenu;
    }


    /**
     *
     * @returns {*}
     */
    getShowCashier() {
        return this._showCashier;
    }


    getPostLoginShowGreeting() {
        return this._postLoginShowGreeting;
    }


    /**
     *
     * @returns {*}
     */
    getShowUserBadge() {
        return this._showUserBadge;
    }


    /**
     *
     * @returns {*}
     */
    getOverlayPriority() {
        return this._overlayPriority;
    }


    /**
     *
     * @returns {*}
     */
    getSilentMode() {
        return this._silentMode;
    }


    /**
     *
     * @returns {number|*}
     */
    getCashierOpenType() {
        return this._cashierOpenType;
    }


    /**
     * Get environment where the component loaded at.
     *
     * @returns {string|*}
     */
    getEnvironment() {
        return this._environment;
    }


    /**
     * Get external handle function for balance click
     * @returns {*}
     */
    getPostCTAClickedFn() {
        return this._postCTAClickedFn;
    }


    /**
     * Get layout name for pre login PC
     * @returns {*}
     */
    getPostLoginLayoutPC() {
        return this._postLoginLayoutPC;
    }


    /**
     * Get layout name for pre login Mobile
     * @returns {*}
     */
    getPostLoginLayoutMobile() {
        return this._postLoginLayoutMobile;
    }


    /**
     * Get custom css selectors for HTML elements
     * @returns {*}
     */
    getStyleSelectors() {
        return this._styleSelectors;
    }
}
export default LoggedinModel;